import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M959.921096 0.0107695155L453 506.931866 605.28095 659.212816 852.225941 412.267824 852.225941 1507.74295 605.28095 1260.79795 453 1413.0789 959.921096 1920 1466.84219 1413.0789 1314.56124 1260.79795 1067.61625 1507.74295 1067.61625 412.267824 1314.56124 659.212816 1466.84219 506.931866z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExpandItemsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandItemsSolid, _Component);

  var _super = _createSuper(IconExpandItemsSolid);

  function IconExpandItemsSolid() {
    _classCallCheck(this, IconExpandItemsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandItemsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandItems",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconExpandItemsSolid.displayName = "IconExpandItemsSolid";
  return IconExpandItemsSolid;
}(Component);

IconExpandItemsSolid.glyphName = 'expand-items';
IconExpandItemsSolid.variant = 'Solid';
IconExpandItemsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandItemsSolid;
export { IconExpandItemsSolid };